import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import {
  getReferPostApi,
  sendMailReferPostApi,
} from "../../services/community";
import toast from "react-hot-toast";
import NotFound from "../../components/not-found/NotFound";
import { RiCommunityLine } from "react-icons/ri";
import { IconButton } from "@mui/material";
import Switch from "../../components/Switch/Switch";
import {
  DatePicker,
  Select,
  dateFormat,
  searchDateFormat,
} from "../../components/Form";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { Button, SecondaryButton } from "../../components/Button/Button";
import ModalBox from "../../components/modal/ModalBox";

import { DescriptionModal, ViewMore } from "../../comman/action/ViewMore";
import { ViewIcon } from "../../comman/action/ViewIcon";

import { PaginationShow } from "../../comman/action/Pagination";

const ReferPostList = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  let searchStartDate = searchParam.get("startDate") || "";
  let searchEndDate = searchParam.get("endDate") || "";
  let createdBy = searchParam.get("createdBy") || "";

  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const [orderByMember, setOrderByMember] = useState("");
  const [orderByCreatedAt, setOrderByCreatedAt] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("ASC");

  const [description, setDescriptionModal] = useState(false);
  const [showDescriptionValue, setShowDescriptionValue] = useState("");

  const [postList, setPostList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [communityName, setCommunityName] = useState("");
  const [statusId, setStatusId] = useState("");

  //-------------handle-see-More-------------
  const handleSeeMore = (about) => {
    setShowDescriptionValue(about);
    setDescriptionModal(true);
  };
  //*********Handel status********* */
  const statusUpdateHandler = (id, isMail, name) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(isMail);
    setCommunityName(name);
  };
  // //*********delete product********* */
  // const deleteHandler = (id, name) => {
  //   setDeleteModal(true);
  //   setDeleteId(id);
  //   setDeleteName(name);
  // };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //*********Handel refresh icon********* */
  const refreshHandler = (event) => {
    setSearch("");
    setDirection("");
    setFieldName("");
    setOrderByCreatedAt("");
    setOrderByMember("");
    searchParam.delete("startDate");
    searchParam.delete("endDate");
    searchParam.delete("status");
    searchParam.delete("createdBy");
    setSearchParam(searchParam);
  };
  //-----------search-createdAt-------------
  const handleCreated = (event) => {
    searchParam.set("createdBy", event.target.value);
    searchParam.set("page", 1);
    setSearchParam(searchParam);
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("startDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParam.set("page", 1);
    searchParam.set("endDate", searchDateFormat(date));
    setSearchParam(searchParam);
  };
  //--------------sorting-member------------------------
  const orderByMemberFun = () => {
    const newDirection = orderByMember === "ASC" ? "DESC" : "ASC";
    setOrderByMember(newDirection);
    setFieldName("totalMembers");
    setDirection(newDirection);
  };
  //--------------sorting-createdAt------------------------
  const orderByCreatedAtFun = () => {
    const newDirection = orderByCreatedAt === "ASC" ? "DESC" : "ASC";
    setOrderByCreatedAt(newDirection);
    setFieldName("createdAt");
    setDirection(newDirection);
  };

  //------------------listing-Api----------------------------------
  const fathPostList = async (
    page = activePage,
    search = debounceValue,
    // sortField = fieldName,
    // sortDirection = direction,
    createdAt = createdBy,
    startDate = searchStartDate,
    endDate = searchEndDate
  ) => {
    try {
      setPostList([]);
      showLoader();
      const res = await getReferPostApi({
        page,
        search,
        // sortField,
        // sortDirection,
        createdBy: createdAt,
        startDate,
        endDate,
      });
      if (res.data.status === 200) {
        setPostList(res?.data?.data?.postListing || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        setPostList([]);
        setTotal(0);
        hideLoader();
        toast.error(res?.data?.message);
      }
    } catch (e) {
      hideLoader();
      toast.error(e.message);
    }
  };
  const sendMail = async () => {
    try {
      let data = { status: !statusValue, id: statusId };
      const res = await sendMailReferPostApi(data);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        setStatusModal(false);

        fathPostList();
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    if (!createdBy) {
      searchParam.delete("createdBy");
    }

    setSearchParam(searchParam);
    fathPostList(activePage, debounceValue, createdBy);
  }, [searchParam, debounceValue, createdBy]);

  useEffect(() => {
    if (
      (searchStartDate && searchEndDate) ||
      (searchStartDate === "" && searchEndDate === "") ||
      (searchStartDate === null && searchEndDate === null)
    ) {
      fathPostList(
        activePage,
        debounceValue,
        // fieldName,
        // direction,
        searchStartDate,
        searchEndDate
      );
    }
    if (!searchStartDate) {
      searchParam.delete("startDate");
    }
    if (!searchEndDate) {
      searchParam.delete("endDate");
    }
    setSearchParam(searchParam);
  }, [searchStartDate, searchEndDate]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Referred Shares</h4>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="search"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {/* --------select-createdBy---------- */}
            <div className="form-group select_width"></div>
            <div className="form-group date_picker">
              <DatePicker
                className="form-control "
                name="startDate"
                selected={searchStartDate}
                placeholder="Start Date"
                onChange={(date) => handleStartDate(date)}
                // maxDate={searchEndDate}
              />
            </div>
            <div className="form-group date_picker">
              <DatePicker
                name="endDate"
                className="form-control"
                placeholder="End Date"
                selected={searchEndDate}
                onChange={(date) => handleEndDate(date)}
                // minDate={searchStartDate}
              />
            </div>
            <div className="form-group refresh_button">
              <SecondaryButton onClick={refreshHandler}>
                <RotateLeftIcon />
              </SecondaryButton>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Post Name</th>
                  <th>
                    <div
                      className="sorting-th"
                      // onClick={orderByCreatedAtFun}
                    >
                      <span>Created At</span>
                      {/* {orderByCreatedAt === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )} */}
                    </div>
                  </th>
                  <th>Created By</th>

                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {postList.length > 0 ? (
                  postList.map(
                    (
                      { _id, content, isRefer, isMail, createdAt, name },
                      index
                    ) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>
                              {" "}
                              <ViewMore
                                value={content}
                                handleSeeMore={handleSeeMore}
                              />
                            </td>
                            <td>{dateFormat(createdAt)}</td>
                            <td>{name}</td>
                            <td>
                              <div className="d-flex justify-content-center align-items-center">
                                <Button
                                  className="Btn1_size"
                                  checked={isMail}
                                  onClick={() =>
                                    statusUpdateHandler(
                                      _id,
                                      isMail,
                                      communityName
                                    )
                                  }
                                  disabled={isMail}
                                >
                                  {isMail ? "Sent" : "Send"}
                                </Button>
                                <ViewIcon
                                  to={`/refer_post-circles/post-Details/${_id}`}
                                />
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Community Found!"
                    icon={<RiCommunityLine style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
        {/* <ChangeCommunityStatus
          show={statusModal}
          close={() => setStatusModal(false)}
          id={statusId}
          status={statusValue}
          listing={fathCommunityList}
          name={communityName}
        /> */}
        {/* --------delete-product-modal---------- */}
        <ModalBox
          status={statusModal}
          onClose={() => setStatusModal(false)}
          title="Refer Post"
          description={
            <span>
              Do you want to Refer this post
              {/* <strong>{deleteName}</strong> */}?
            </span>
          }
          // description="Do you want to delete this community?"
          action={sendMail}
        />

        {/* --------show-product-modal-description-if-large---------- */}
        <DescriptionModal
          show={description}
          close={() => setDescriptionModal(false)}
          title="About & Purpose"
          value={showDescriptionValue}
        />
      </div>
    </>
  );
};
export default ReferPostList;
